/** The maximum length of a search query term for Substrate Search */ export const MaxSubstrateSearchQueryTermLength = 200;
